export default __webpack_public_path__ + "static/media/react-img.ef20e673.png";